<div class="modal-container">

  <div class="new-task-header">
    <div (click)="onCancel()" class="close-button" role="button" tabindex="0"
      [attr.aria-label]="'common.close' | translate" (keydown)="onCloseButtonKeydown($event)">
      <img src="../../../../../assets/icons/close-cross-icon.webp" [attr.alt]="'common.close' | translate">
    </div>
    <div>
      <h2 id="modalTitle">{{ modalTitle }}</h2>
    </div>
  </div>

  <form [formGroup]="taskForm" class="new-task-content" *ngIf="!loadingTask" role="form"
    [attr.aria-labelledby]="'modalTitle'">

    <div class="form-group">
      <label for="taskName">
        <span class="label-text-with-required">
          {{ 'myTasks.create_task.name' | translate }}
          <span class="required" aria-label="required">*</span>
        </span>
        <span class="char-counter" *ngIf="characterCount.name > 0">
          {{characterCount.name}}/{{100}}
        </span>
      </label>
      <input #nameInput id="taskName" type="text" class="form-control" formControlName="name"
        [placeholder]="'myTasks.create_task.placeholder.name' | translate"
        [class.is-invalid]="taskForm.controls.name.invalid && taskForm.controls.name.touched"
        [attr.aria-describedby]="taskForm.controls.name.invalid && taskForm.controls.name.touched ? 'nameError' : null"
        [attr.aria-invalid]="taskForm.controls.name.invalid && taskForm.controls.name.touched" />
      <small id="nameError" class="error-message"
        *ngIf="taskForm.controls.name.invalid && taskForm.controls.name.touched" role="alert">
        <span *ngIf="taskForm.controls.name.errors?.['required']">
          {{ 'myTasks.create_task.error.field_required' | translate }}
        </span>
        <span *ngIf="taskForm.controls.name.errors?.['maxlength']">
          {{ 'myTasks.create_task.error.max_length' | translate: { max: 100 } }}
        </span>
      </small>
    </div>

    <div class="form-group">
      <label for="taskDescription">
        <span class="label-text-with-required">
          {{ 'myTasks.create_task.description' | translate }}
          <span class="required" aria-label="required">*</span>
        </span>
        <span class="char-counter" *ngIf="characterCount.description > 0">
          {{characterCount.description}}/{{500}}
        </span>
      </label>
      <textarea id="taskDescription" class="form-control" formControlName="description" rows="3"
        [placeholder]="'myTasks.create_task.placeholder.description' | translate"
        [class.is-invalid]="taskForm.controls.description.invalid && taskForm.controls.description.touched"
        [attr.aria-describedby]="taskForm.controls.description.invalid && taskForm.controls.description.touched ? 'descriptionError' : null"></textarea>
      <small id="descriptionError" class="error-message"
        *ngIf="taskForm.controls.description.invalid && taskForm.controls.description.touched" role="alert">
        <span *ngIf="taskForm.controls.description.errors?.['required']">
          {{ 'myTasks.create_task.error.field_required' | translate }}
        </span>
        <span *ngIf="taskForm.controls.description.errors?.['maxlength']">
          {{ 'myTasks.create_task.error.max_length' | translate: { max: 500 } }}
        </span>
      </small>
    </div>

    <div class="form-group">
      <label for="vehicleSearcher">
        <span class="label-text-with-required">
          {{ 'myTasks.create_task.vehicle' | translate }}
          <span class="required" aria-label="required">*</span>
        </span>
      </label>

      <app-reusable-searcher #vehicleSearcher id="vehicleSearcher" [selectedItem]="taskForm.controls.vehicle.value"
        [placeholder]="'pages.budget.addInfo.searchVehiclePlaceholder' | translate"
        (search)="searchVehiclesSearcher($event)" (itemSelected)="selectVehicle($event)" [displayField]="'licensePlate'"
        [attr.aria-describedby]="taskForm.controls.vehicle.invalid && taskForm.controls.vehicle.touched ? 'vehicleError' : null">
      </app-reusable-searcher>

      <small id="vehicleError" class="error-message"
        *ngIf="taskForm.controls.vehicle.invalid && taskForm.controls.vehicle.touched" role="alert">
        {{ 'myTasks.create_task.error.field_required' | translate }}
      </small>
      <small class="helper-text" *ngIf="!taskForm.controls.vehicle.value">
        {{ 'myTasks.create_task.helper.vehicle_search' | translate }}
      </small>
    </div>

    <div class="form-row">
      <div class="form-group">
        <label for="brandModel">
          <span class="label-text-with-required">
            {{ 'myTasks.create_task.brandModel' | translate }}
            <span class="required" aria-label="required">*</span>
          </span>
        </label>
        <input id="brandModel" type="text" class="form-control" formControlName="brandModel"
          [placeholder]="'myTasks.create_task.placeholder.brandModel' | translate"
          [class.is-invalid]="taskForm.controls.brandModel.invalid && taskForm.controls.brandModel.touched" />
        <small class="error-message"
          *ngIf="taskForm.controls.brandModel.invalid && taskForm.controls.brandModel.touched" role="alert">
          {{ 'myTasks.create_task.error.field_required' | translate }}
        </small>
      </div>

      <div class="form-group">
        <label for="clientName">
          <span class="label-text-with-required">
            {{ 'myTasks.create_task.client' | translate }}
            <span class="required" aria-label="required">*</span>
          </span>
        </label>
        <div id="clientName" class="readonly-field" role="textbox" [attr.aria-readonly]="true"
          [attr.aria-describedby]="'clientNameHelper'">
          <span class="readonly-value" *ngIf="taskForm.controls.clientName.value; else emptyClient">
            {{ taskForm.controls.clientName.value }}
          </span>
          <ng-template #emptyClient>
            <span class="readonly-placeholder">
              {{ 'myTasks.create_task.placeholder.client' | translate }}
            </span>
          </ng-template>
        </div>
        <small id="clientNameHelper" class="helper-text readonly-info">
          {{ 'myTasks.create_task.helper.client_info' | translate }}
        </small>
        <small class="error-message"
          *ngIf="taskForm.controls.clientName.invalid && taskForm.controls.clientName.touched" role="alert">
          {{ 'myTasks.create_task.error.field_required' | translate }}
        </small>
      </div>
    </div>

    <div class="form-group">
      <label for="executionDate">
        <span class="label-text-with-required">
          {{ 'myTasks.create_task.execution_date' | translate }}
          <span class="required" aria-label="required">*</span>
        </span>
      </label>
      <app-date-input id="executionDate" formControlName="executionDate" [required]="true" [fullWidth]="true"
        [showLabel]="false"
        [attr.aria-describedby]="taskForm.controls.executionDate.invalid && taskForm.controls.executionDate.touched ? 'executionDateError' : null">
      </app-date-input>
      <small id="executionDateError" class="error-message"
        *ngIf="taskForm.controls.executionDate.invalid && taskForm.controls.executionDate.touched" role="alert">
        {{ 'myTasks.create_task.error.field_required' | translate }}
      </small>
    </div>

    <div class="form-group">
      <label for="expirationDate">
        <span class="label-text-with-required">
          {{ 'myTasks.create_task.expiration_date' | translate }}
          <span class="required" aria-label="required">*</span>
        </span>
      </label>
      <app-date-input id="expirationDate" formControlName="expirationDate" [required]="true" [fullWidth]="true"
        [showLabel]="false"
        [attr.aria-describedby]="taskForm.controls.expirationDate.invalid && taskForm.controls.expirationDate.touched ? 'expirationDateError' : null">
      </app-date-input>
      <small id="expirationDateError" class="error-message"
        *ngIf="taskForm.controls.expirationDate.invalid && taskForm.controls.expirationDate.touched" role="alert">
        {{ 'myTasks.create_task.error.field_required' | translate }}
      </small>
    </div>

    <div class="form-validation-error" *ngIf="hasDateValidationError" role="alert">
      <span class="error-icon">⚠</span>
      <span>{{ 'myTasks.create_task.error.expiration_before_execution' | translate }}</span>
    </div>
  </form>

  <div class="modal-footer">
    <button type="button" class="btn btn-secondary" (click)="onCancel()" [disabled]="saveLoading"
      [attr.aria-label]="'common.cancel' | translate">
      {{ 'common.cancel' | translate }}
    </button>
    <button type="submit" class="btn btn-primary" (click)="saveTask()" [disabled]="!isFormValid || saveLoading"
      [attr.aria-label]="saveButtonLabel" [class.btn-loading]="saveLoading">
      <mat-spinner *ngIf="saveLoading" diameter="18" strokeWidth="3" class="btn-spinner"></mat-spinner>
      <span [class.btn-text-hidden]="saveLoading">{{ saveButtonLabel }}</span>
    </button>
  </div>

  <div *ngIf="loadingTask" class="loading-overlay" role="status" aria-live="polite">
    <mat-spinner diameter="40" strokeWidth="3"></mat-spinner>
    <p class="loading-text">{{ 'common.loading' | translate }}</p>
  </div>
</div>